import React from "react";
import ImmobilisationTable from "./ImmobilisationTable";
import Paper from '@material-ui/core/Paper';
import { Grid } from "@material-ui/core";
function ImmoList(props) {
    const isGenerateQrCode = props.isGenerateQrCode;
    const filterCount = props.filterCount;
    const isImputChanged = props.isImputChanged;
    return (
        <ImmobilisationTable isExtra={0} isGenerateQrCode={isGenerateQrCode} filterCount={filterCount} isImputChanged={isImputChanged}/>
    );
}
export default ImmoList